import TextInput from 'components/Common/Form/Input/TextInput'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import LineSearchIcon from 'components/Luxkit/Icons/line/LineSearchIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useState } from 'react'
import noop from 'lib/function/noop'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { GoogleAutocompletePlaceItem } from 'api/search'
import useExperiencesPlaceAutocomplete from '../hooks/useExperiencePlaceAutocomplete'

interface Props {
  defaultSearchPhrase?: string;
  onSelect?: (option: GoogleAutocompletePlaceItem) => void;
  selectedPlaceId?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  className?: string;
  originAirport: App.Airport;
}

function ExperienceTransferBookingHotelSelectOptions(props: Props) {
  const {
    className,
    defaultSearchPhrase,
    onSelect = noop,
    selectedPlaceId,
    inputRef,
    originAirport,
  } = props

  const [searchPhrase, setSearchPhrase] = useState<string>(defaultSearchPhrase ?? '')

  const { isLoading, predictions } = useExperiencesPlaceAutocomplete(searchPhrase, {
    latitude: originAirport.latitude,
    longitude: originAirport.longitude,
    radius: 100000,
  })

  const noResultsFound = !isLoading && predictions.length === 0 && searchPhrase?.length > 1
  const onItemSelect = (e: React.MouseEvent<HTMLButtonElement>) => {
    const placeId = e.currentTarget.dataset.placeid
    const option = predictions.find(p => p.placeId === placeId)
    onSelect(option)
  }

  return <VerticalSpacer gap={12} className={className}>
    <TextInput
      autoComplete="off"
      onChange={(e) => setSearchPhrase(e.currentTarget.value)}
      endIcon={<LineSearchIcon />}
      defaultValue={searchPhrase}
      ref={inputRef}
      placeholder="Search by hotel or address"
      noValidationSpacing
    />
    {!isLoading && predictions.length > 0 && <div>
      {predictions.map(option => (
        <ListItem
          key={option.placeId}
          selected={option.placeId === selectedPlaceId}
          data-placeid={option.placeId}
          onClick={onItemSelect}
          size="medium"
          title={option.mainText}
          subtitle={option.secondaryText}
          startIcon={<LineMapMarkerIcon />}
        />
      ))}
    </div>}
    {!isLoading && noResultsFound && (
      <div>
        <BodyText variant="medium" colour="neutral-two">
          Sorry, we couldn’t find results for{' '}
          <BodyText
          colour="neutral-one"
          as="span"
          variant="medium"
          weight="semi-bold"
        >
            '{searchPhrase}'
          </BodyText>
          .
        </BodyText>
        <BodyText variant="large" colour="neutral-two">
          Try a different search phrase
        </BodyText>
      </div>
    )}
    {isLoading && <LoadingIndicator inline />}
  </VerticalSpacer>
}

export default ExperienceTransferBookingHotelSelectOptions
